import { Box } from "@twilio-paste/core/box";
import { Text } from "@twilio-paste/core/text";
import { copy } from "../../views/IntelligentAssistant/definitions";
import {
  Popover,
  PopoverButton,
  PopoverContainer,
} from "@twilio-paste/core/popover";
import { InformationIcon } from "@twilio-paste/icons/esm/InformationIcon";
import { CustomizationProvider } from "@twilio-paste/core/customization";

const ChatFreeFormQuestionPopover = (): JSX.Element => {
  return (
    <CustomizationProvider
      elements={{
        POPOVER_BUTTON: {
          marginTop: "space40",
        },
      }}
    >
      <PopoverContainer
        baseId="free-form-question-popover"
        data-testid="free-form-question-popover-container"
      >
        <PopoverButton
          variant="reset"
          size="reset"
          data-testid="free-form-question-popover-btn"
        >
          <InformationIcon
            decorative={false}
            title="Open Tooltip"
            display="block"
            color="colorTextWeak"
          />
          <Text
            as="span"
            fontSize="fontSize20"
            color="colorTextWeak"
            fontWeight="fontWeightLight"
          >
            What kind of questions can I ask?
          </Text>
        </PopoverButton>
        <Popover
          aria-label="Popover"
          width="size40"
          data-testid="free-form-question-popover"
        >
          <Text as="p" marginBottom="space30">
            {copy.generalCopy.tooltips.freeFormQuestionText}
          </Text>
          <Box
            data-testid="free-form-question-examples"
            padding="space30"
            backgroundColor="colorBackgroundPrimaryWeakest"
          >
            <Text as="p">
              {copy.generalCopy.tooltips.freeFormQuestionExamplesIntro}
            </Text>
            <ul>
              {copy.generalCopy.tooltips.freeFormQuestionExamples.map(
                (example, index) => (
                  <li key={index}>{example}</li>
                )
              )}
            </ul>
          </Box>
        </Popover>
      </PopoverContainer>
    </CustomizationProvider>
  );
};

export default ChatFreeFormQuestionPopover;
